import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import * as helpConfigurationActions from 'action/helpConfiguration'

import _ from 'lodash'

import ContentHeader from 'component/utils/ContentHeader'
import Breadcrumb from 'component/Breadcrumb'
import Table from 'component/helpConfiguration/Table'
import Grid from 'component/utils/Grid'
import Row from 'component/utils/Row'
import Pagination from 'component/pagination/Pagination'
import Tilte from 'component/helpConfiguration/Title'
import Filter from 'component/helpConfiguration/Filter'
import HelpConfigModal from 'component/helpConfiguration/Modal/HelpConfigModal'

const DEFAULT_PAGE = 1
const DEFAULT_SIZE = 10

const REMOVE = 'HELP_CONFIG_REMOVE'
const EDIT = 'HELP_CONFIG_EDIT'
const NEW = 'HELP_CONFIG_NEW'
const SUCCESS = 'HELP_CONFIG_SUCCESS'

class HelpContainer extends Component {
  constructor() {
    super()
    this.filterRef = React.createRef()
    this.titleRef = React.createRef()
    this.state = {
      filters: {
        page: DEFAULT_PAGE,
        size: DEFAULT_SIZE,
      },
      visible: false,
      modalType: false,
      callbackMsg: null,
      data: {},
      view: false,
      paginationStyle: {},
      topMargin: 0,
    }
  }

  componentDidMount() {
    const {
      auth: { user },
      fetchHelpConfig,
    } = this.props

    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)

    fetchHelpConfig(user.dsToken, this.state.filters, this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile.register') },
      { title: translate('menu.help.config'), strong: true },
    ]

    return <Breadcrumb steps={steps} />
  }

  handleDelete = (data) => {
    this.setState({
      modalType: REMOVE,
      data,
    })
  }

  handleUpdate = (data, view = false) => {
    this.setState({
      modalType: EDIT,
      data,
      view,
    })
  }

  handleFetch = (filters) => {
    const {
      auth: { user },
      fetchHelpConfig,
    } = this.props

    const newFilter = {
      filters,
      page: DEFAULT_PAGE,
      size: DEFAULT_SIZE,
    }

    this.setState({ filters: newFilter }, () => {
      fetchHelpConfig(user.dsToken, this.state.filters)
    })
  }

  handlePagination = (page) => {
    const {
      auth: { user },
      fetchHelpConfig,
    } = this.props

    const newFilter = {
      ...this.state.filters,
      page,
      size: DEFAULT_SIZE,
    }

    this.setState({ filters: newFilter }, () => {
      fetchHelpConfig(user.dsToken, this.state.filters)
    })
  }

  handleCollapse = (visible) => {
    this.setState({ visible })
  }

  onSubmit = () => {
    const { filterRef, titleRef } = this
    const {
      auth: { user },
      fetchHelpConfig,
    } = this.props

    const dsTitle = titleRef.current.state.dsTilte
    const menus = filterRef.current.state.func
    const types = filterRef.current.state.type
    const listTypeConfig = []

    if (types.typetext) {
      listTypeConfig.push(0)
    }

    if (types.typevideo) {
      listTypeConfig.push(1)
    }

    const newFilter = {
      ...this.state.filters,
      dsTitle,
      listTypeConfig,
      listCdMenus: Object.entries(menus)
        .filter((e) => e[1] === 1 && e[0] !== 'menuAll')
        .map((e) => parseInt(e[0], 10)),
    }

    this.setState({ filters: newFilter }, () => {
      fetchHelpConfig(user.dsToken, this.state.filters)
    })
  }

  toggleModal = (modalType) => {
    this.setState({ modalType })
  }

  handleSave = (values) => {
    const {
      auth: { user },
      saveHelpConfig,
    } = this.props
    saveHelpConfig(user.dsToken, values, this.onSuccessAction)
  }

  onSuccessAction = (data, msg) => {
    this.toggleModal(SUCCESS)
    this.setState({ callbackMsg: msg })
  }

  remove = (value) => {
    const {
      auth: { user },
      removeHelpConfig,
    } = this.props
    removeHelpConfig(user.dsToken, value, this.onSuccessAction)
  }

  renderModal = () => {
    const {
      translate,
      auth: { user },
    } = this.props

    const { modalType, data, view } = this.state

    if (modalType) {
      switch (modalType) {
        case NEW:
          return (
            <HelpConfigModal
              translate={translate}
              user={user}
              onSubmit={this.handleSave}
              closeModal={this.toggleModal}
              modalType={'HELP_CONFIG_NEW'}
              initialValues={{ typeConfig: '0' }}
            />
          )
        case SUCCESS:
          return (
            <HelpConfigModal
              translate={translate}
              closeModal={() => {
                this.toggleModal()
                this.onSubmit()
              }}
              modalType={'HELP_CONFIG_SUCCESS'}
              msg={this.state.callbackMsg}
            />
          )
        case EDIT:
          return (
            <HelpConfigModal
              translate={translate}
              user={user}
              onSubmit={this.handleSave}
              closeModal={this.toggleModal}
              modalType={'HELP_CONFIG_EDIT'}
              disabled={view}
              initialValues={{
                ...data,
                typeConfig: data.typeConfig.toString(),
              }}
            />
          )
        case REMOVE:
          return (
            <HelpConfigModal
              translate={translate}
              closeModal={() => {
                this.toggleModal()
              }}
              onSubmit={this.remove}
              modalType={'HELP_CONFIG_REMOVE'}
              msg={data.dsTitle}
              data={data}
              size={'sm'}
            />
          )
        default:
          return <Fragment />
      }
    }
  }

  handleResize = () => {
    const { topMargin } = this.state

    if (!_.isEmpty(this.refs) && window.innerWidth > 768) {
      const { header } = this.refs
      const { filter } = this.refs
      const topHeight = header.clientHeight

      filter.style.top = `${header.clientHeight}px`

      if (topMargin !== topHeight) {
        this.setState({ topMargin: topHeight })
      }
    }
  }

  handleScroll = () => {
    const scroll = document.documentElement.scrollLeft

    const screen = window.innerWidth
    const content = document.body.scrollWidth
    const maxScroll = content - screen

    if (scroll < maxScroll) {
      this.setState({
        paginationStyle: {
          marginLeft: scroll,
          marginRight: -scroll,
        },
      })
    }
  }

  render() {
    const {
      translate,
      records,
      pages,
      count,
      current,
      auth: { user },
    } = this.props

    const { visible, paginationStyle } = this.state

    return (
      <section
        className='rotative-inventory stock-adjustment'
        style={{ overflowX: 'hidden' }}
      >
        <div ref={'header'} className={'rotative-inventory-header'}>
          <ContentHeader>{translate('menu.help.config')}</ContentHeader>

          {this.renderBreadcrumb()}
        </div>

        <div ref={'filter'}>
          <Tilte
            ref={this.titleRef}
            translate={translate}
            visible={visible}
            handleCollapse={this.handleCollapse}
            onSubmit={this.onSubmit}
            toggleModal={this.toggleModal}
          />

          <Grid fluid>
            <div style={{ display: 'flex' }}>
              <Filter
                ref={this.filterRef}
                translate={translate}
                visible={visible}
                user={user}
                onSubmit={this.onSubmit}
              />

              <Table
                translate={translate}
                records={records}
                handleUpdate={this.handleUpdate}
                handleDelete={this.handleDelete}
                visible={visible}
              />
            </div>

            {pages > 1 && (
              <Row>
                <div
                  className='align-center rupture-irc-pagination'
                  style={paginationStyle}
                >
                  <Pagination
                    getPage={this.handlePagination}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                </div>
              </Row>
            )}
          </Grid>
        </div>
        {this.renderModal()}
      </section>
    )
  }
}

HelpContainer.propTypes = {
  count: PropTypes.number,
  current: PropTypes.number,
  pages: PropTypes.number,
  records: PropTypes.array.isRequired,
  fetchHelpConfig: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  saveHelpConfig: PropTypes.func.isRequired,
  removeHelpConfig: PropTypes.func.isRequired,
}

/* istanbul ignore next */
const mapStateToProps = ({ helpConfiguration, paginateReducer }) => ({
  records: helpConfiguration.list.records,
  count: paginateReducer.count,
  current: paginateReducer.current,
  pages: paginateReducer.pages,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(helpConfigurationActions, dispatch)

const HelpContainerTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(HelpContainer)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpContainerTranslated)

export { HelpContainer }
